/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ScanFrameBarcodeClassicIcon16Light } from './ScanFrameBarcodeClassicIcon16Light';
import { ScanFrameBarcodeClassicIcon16Regular } from './ScanFrameBarcodeClassicIcon16Regular';
import { ScanFrameBarcodeClassicIcon16Solid } from './ScanFrameBarcodeClassicIcon16Solid';
import { ScanFrameBarcodeClassicIcon20Light } from './ScanFrameBarcodeClassicIcon20Light';
import { ScanFrameBarcodeClassicIcon20Regular } from './ScanFrameBarcodeClassicIcon20Regular';
import { ScanFrameBarcodeClassicIcon20Solid } from './ScanFrameBarcodeClassicIcon20Solid';
import { ScanFrameBarcodeClassicIcon24Regular } from './ScanFrameBarcodeClassicIcon24Regular';
import { ScanFrameBarcodeClassicIcon24Solid } from './ScanFrameBarcodeClassicIcon24Solid';
import { ScanFrameBarcodeClassicIcon32Regular } from './ScanFrameBarcodeClassicIcon32Regular';
import { ScanFrameBarcodeClassicIcon64Regular } from './ScanFrameBarcodeClassicIcon64Regular';
var sizes = {
    16: {
        light: ScanFrameBarcodeClassicIcon16Light,
        regular: ScanFrameBarcodeClassicIcon16Regular,
        solid: ScanFrameBarcodeClassicIcon16Solid,
    },
    20: {
        light: ScanFrameBarcodeClassicIcon20Light,
        regular: ScanFrameBarcodeClassicIcon20Regular,
        solid: ScanFrameBarcodeClassicIcon20Solid,
    },
    24: {
        regular: ScanFrameBarcodeClassicIcon24Regular,
        solid: ScanFrameBarcodeClassicIcon24Solid,
    },
    32: {
        regular: ScanFrameBarcodeClassicIcon32Regular,
    },
    64: {
        regular: ScanFrameBarcodeClassicIcon64Regular,
    },
};
export var ScanFrameBarcodeClassicIcon = forwardRef('ScanFrameBarcodeClassicIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
